<template>
  <div class="distribution-wrapper">
    <app-markets-nav :navItems="navItems"></app-markets-nav>
    <div class="distribution-content">
      <h4 class="distribution-h4 indent" id="distribution-1">Nastri e lamiere  standard</h4>
      <p class="distribution-p indent">La leggerezza dell'alluminio, la buona resistenza alla corrosione e la sua formabilità ne fanno un eccellente materiale ingegneristico con una varietà di applicazioni in tutti i settori industriali. I nastri e le lamiere di alluminio standard vengono solitamente forniti a distributori e centri di assistenza per il successivo utilizzo nell'edilizia, nell'industria elettrotecnica e in altri settori industriali.</p>
      <div class="distribution-img" :style="{backgroundImage: 'url(' + '/static/img/markets/distribution/img_1.jpg' + ')'}"></div>
      <h4 class="distribution-h4 indent" id="distribution-2">Profili standard</h4>
      <p class="distribution-p indent">I profili con forme standard (tubi e barre quadrati/rettangolari/tondi, angoli, profili a T, profili a U, profili a Z, profili ad H) vengono solitamente forniti ai distributori per essere utilizzati per una varietà di applicazioni, principalmente nell'edilizia e nelle costruzioni. Alcomet ha oltre 7.500 diverse  forme  disponibili.</p>
      <div class="distribution-img" :style="{backgroundImage: 'url(' + '/static/img/markets/distribution/img_2.jpg' + ')'}"></div>
      <app-share-button></app-share-button>
    </div>
  </div>
</template>

<script>
import ShareButton from "../shared/ShareButton";
import MarketsNav from "./MarketsNav";
export default {
  components: {
    appShareButton: ShareButton,
    appMarketsNav: MarketsNav
  },
  data() {
    return {
      navItems: [
        ["distribution-1", "Nastri e lamiere  standard"],
        ["distribution-2", "Profili standard"]
      ]
    };
  }
};
</script>

<style scoped>
.distribution-wrapper {
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: 20px;
}
/* CONTENT */
.distribution-content {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 80%;
}
.distribution-p {
  font-size: 19px;
  margin: 15px 0;
  text-align: justify;
  line-height: 32px;
  width: 60%;
}
.distribution-link {
  font-size: 19px;
  text-decoration: underline;
}
.distribution-h4 {
  font-size: 22px;
  font-weight: 500;
  line-height: 32px;
  margin: 15px 0;
  text-align: justify;
  width: 60%;
}
.distribution-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 5px;
  min-height: 280px;
  margin: 20px 0;
  width: 80%;
}
@media screen and (max-width: 1000px) {
  .distribution-content {
    width: 100%;
  }
  .distribution-h4 {
    font-size: 18px;
    padding: 0 30px;
    width: 100%;
  }
  .distribution-p {
    font-size: 16px;
    margin: 15px 0;
    padding: 0 30px;
    width: 100%;
  }
  .distribution-link {
    font-size: 16px;
  }
  .distribution-img {
    min-height: 30vw;
    margin: 20px 30px;
    width: calc(100% - 60px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/markets/Distribution.vue